import React, { Fragment } from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Grid, TextField, InputAdornment } from '@material-ui/core';
import { fieldDateFormat, backendDateFormat } from '../../../constants';
import { regexConstants } from '../../../constants/regEx';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { outlinedLabel } from './OutlinedFieldLabel';

const FbvInputs = ({ valuationCrud, onFieldChange, updateErrorField, error, mode }) => {
  return (
    <Fragment>
      <Grid item xs={12} md={4}>
        <TextField
          id="escalation_percentage"
          label={outlinedLabel('Inflation Rate', {
            required: true,
            tip: 'Value should be between 0.0% to 5.0%.',
          })}
          placeholder="Enter value between 0.0%–5.0%"
          fullWidth
          margin="normal"
          disabled={mode === 'view'}
          inputProps={{ maxLength: 10 }}
          InputLabelProps={{ shrink: true }}
          value={valuationCrud.escalation_percentage}
          onChange={(e) => {
            const next = e.target.value;
            const num = parseFloat(next || 0);
            if ((regexConstants.numberWithDot.test(next) || next === '') && num >= 0 && num <= 5) {
              onFieldChange(e, 'escalation_percentage', next);
              updateErrorField('escalation_percentage', '');
            } else {
              e.preventDefault();
            }
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          variant="outlined"
          error={error.escalation_percentage ? true : false}
          helperText={error.escalation_percentage ? error.escalation_percentage : ''}
          onFocus={() => updateErrorField('escalation_percentage', '')}
          autoComplete='off'
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            autoComplete='off'
            margin="normal"
            id="projection_to"
            label={outlinedLabel('Projection To', { required: true })}
            format={fieldDateFormat}
            disabled={mode === 'view'}
            fullWidth
            disablePast={true}
            minDate={moment().add(1, 'days')}
            maxDate={valuationCrud.asset_type && valuationCrud.asset_type === 2 ? valuationCrud.base_value_date ? moment(valuationCrud.base_value_date).add(10, 'years').endOf('year') : moment().add(10, 'years').endOf('year') : valuationCrud.date_of_manufacture ? moment(valuationCrud.date_of_manufacture).add(9131.25, 'days') : moment().add(9125, 'days')}
            InputLabelProps={{ shrink: true }}
            onChange={(data, value) => onFieldChange(value, 'projection_to', data ? moment(data).format(backendDateFormat) : data)}
            value={valuationCrud.projection_to}
            error={error.projection_to ? true : false}
            helperText={error.projection_to ? error.projection_to : ''}
            onFocus={() => updateErrorField('projection_to', '')}
            onOpen={() => updateErrorField('projection_to', '')}
            inputVariant="outlined"
            inputProps={{ readOnly: false }}
            placeholder="DD-MM-YYYY"
          />
        </MuiPickersUtilsProvider>
      </Grid>
    </Fragment>
  )
}
export default FbvInputs;
